import React, { useCallback } from 'react'
import { Modal } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { accountTransReportSelector } from 'app-redux/selectors'
import { hideAccountTransactionReport } from 'app-redux/finance/actions'
import { Cancel, RestrictedPage } from 'components/UI'
import AccountTransactions from './index'

const AccountTransactionModal = () => {
  const dispatch = useDispatch()
  const accountTrans = useSelector(accountTransReportSelector)

  const hideHandler = useCallback(() => dispatch(hideAccountTransactionReport()), [dispatch])

  return (
    <Modal
      open={accountTrans.show}
      onCancel={hideHandler}
      footer={[<Cancel key={`_${0}`} onClick={hideHandler} />]}
      destroyOnHidden
      width="90%"
      closable={false}
      styles={{
        body: { overflowY: 'auto', maxHeight: 'calc(100vh - 150px)', position: 'relative' },
      }}
    >
      <RestrictedPage code="report_general_ledger">
        <AccountTransactions params={accountTrans.params} isOnModal />
      </RestrictedPage>
    </Modal>
  )
}

export default AccountTransactionModal
